import styled from 'styled-components';

export const BenefitsBox = styled.div`
  padding: 10px 0;

  @media(min-width: 1200px) {
    padding: 20px 0;
  }
`;

export const BenefitsInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BenefitBox = styled.div`
  display: flex;
  gap: 11px;
`;

export const BenefitIcon = styled.div`
  color: #0077FF;
  > svg {
    width: 24px;
    height: 24px;
  }
`;

export const BenefitText = styled.div`
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 160%;
  color: #475266;
`;

BenefitsBox.displayName = 'BenefitsBox';
BenefitsInner.displayName = 'BenefitsInner';
BenefitBox.displayName = 'BenefitBox';
BenefitIcon.displayName = 'BenefitIcon';
BenefitText.displayName = 'BenefitText';
